export default "__VITE_ASSET__CD2Pummk__"